import React, { useState, useEffect, useRef } from 'react';
import Moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { FaFilePdf } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';
import blockchainImg from '../../assests/blockchain.svg';

import './styles.css';

export default function Negociacoes() {
  const { t } = useTranslation();
  const history = useHistory();
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);

  function calculaTempo(data) {
    let dateObj = new Date(data);
    let lang = 'pt-br';
    let tz = 'America/Sao_Paulo';
    return dateObj.toLocaleString(lang, {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
  }

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [filtro, setFiltro] = useState(() => sessionStorage.getItem('negFiltro') || 'all');
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const BASE_URL = sessionStorage.getItem('BASE_URL');

  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const PARAMS = '';

  useEffect(() => {
    let cancelled = false;
    loadingRef.current = true;
    setLoadingMore(true);

    api.get(`/v6/users/me/negotiations?page=${page}&type=${filtro}`, {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        PARAMS,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (cancelled) return;
      const data = Array.isArray(response.data) ? response.data : [];
      setPosts((prev) => (page === 1 ? data : prev.concat(data)));
      setHasMore(data.length > 0);
      sessionStorage.setItem('sPosts', JSON.stringify(data));
      sessionStorage.setItem('page', page);
    }).catch(() => {
      if (!cancelled) history.push('/');
    }).finally(() => {
      if (!cancelled) {
        loadingRef.current = false;
        setLoadingMore(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [USER_EMAIL, USER_TOKEN, history, page, filtro]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      if (loadingRef.current || !hasMore) return;
      setPage((current) => current + 1);
    }, { rootMargin: '240px' });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, posts.length]);

  function carregarNegociacao(nextFiltro) {
    sessionStorage.setItem('negFiltro', nextFiltro);
    if (nextFiltro === filtro && page === 1) return;
    setPosts([]);
    setHasMore(true);
    setPage(1);
    setFiltro(nextFiltro);
  }

  function tipo_pagamento(tipo) {
    switch (tipo) {
      case 'fifteen_kilos':
        return 'Arroba';
      case 'sacs':
        return 'Saca';
      case 'tons':
        return 'Tonelada';
      case 'head':
        return 'Cabeça';
      default:
        return "Cabeça";
    }
  };

  function formataData(data, formato) {
    // Moment.locale('pt-BR');
    let tempo = (Moment(data, formato));
    return tempo;
  }

  function payment_form(pgto) {
    if (pgto > 0) {
      return 'À Prazo - ' + pgto + 'dia(s)';
    } else {
      return 'À Vista';
    }
  }
  function tax_form(forma) {
    switch (forma) {
      case 'to_charge':
        return 'Pagamento sobre a folhas 20%';
      case 'free':
        return 'À descontar 1,5% na comercialização';
      default:
        return 'Livre de impostos'
    }
  }
  function payment_measure(forma) {
    switch (forma) {
      case 'fifteen_kilos':
        return 'por arroba';
      case 'sacs':
        return 'por saca';
      case 'tons':
        return 'por tonelada';
      case 'head':
        return 'por cabeça';
      default:
        return ''
    }
  }

  function Description(props) {
    let texto = props.texto.substring(0, 220);
    //texto = texto.replace(/(?:\r\n|\r|\n)/g, '<br/>');
    //texto = String(texto);
    return (
      <p className="description">{texto}</p>
    )
  }
  function dataFormatada(date) {
    var data = date,
      dia = data.getDate().toString(),
      diaF = (dia.length == 1) ? '0' + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = (mes.length == 1) ? '0' + mes : mes,
      anoF = data.getFullYear();
    return diaF + "/" + mesF + "/" + anoF;
  }
  // function converterBase64ParaBlob(base64, contentType){
  //   let respostaBruta = window.atob(base64);
  //   let tamanhoDaResposta = raw.length;
  //   let cache = new Uint8Array(new ArrayBuffer(tamanhoDaResposta ));
  //   for(let i = 0; i < rawLength; i++) {
  //       cache[i] = respostaBruta.charCodeAt(i);
  //   }
  //   let blob = new Blob([cache],{type: contentType} );
  //   return blob;
  // }
  function baixarPDF(id) {
    var axios = require('axios');
    var config = {
      method: 'get',
      url: BASE_URL + `/v5/users/me/negotiations/${id}/pdf`,
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN
      }
    };
    axios(config)
      .then(function (response) {
        let blob = response.data;
        let file = new Blob([blob], { type: "application/pdf" });
        let fileURL = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
        window.open(fileURL);
        // let cabecalho = response.headers();
        // let arquivo = converterBase64ParaBlob(response.data, cabecalho['content-type']);
        // saveAs(arquivo, "download.pdf");
      }).catch(function (error) {
      });
  }


  function renderSwitch(param) {
    switch (param) {
      case 'live_weight':
        return 'Forma de Abate: Peso Vivo\n';
      case 'dead_weight':
        return 'Forma de Abate: Peso Morto\n';
      default:
        return '';
    }
  }

  function mostraNegociacao(data) {
    if(!data){
      return false;
    }
    return(
      <p className="description">Data de entrega: {Moment(data).format("DD/MM/YYYY")}</p>
    )
  }

  function ItemNeg() {
    return (

      posts.map(neg =>
        (neg.negotiations || []).map(negoc => (
          <li key={negoc.id}>
            { negoc.reviewer_status === "approved" &&
              <div className="blockchain">
                <span className="blockchain-text">VALIDADO NA BLOCKCHAIN</span>
                <img src={blockchainImg} alt="blockchain"/>
              </div>
            }
            {mostrarEditar(negoc)}
            {/* <div className="edit"><Link to={'/negocio/alterar/' + negoc.id}><FiEdit />Editar</Link></div> */}
            <p className="nome">{(negoc.kind === 'sale') ? 'Venda' : 'Compra'} - <span className="data">{Moment(negoc.negotiation_date).format('DD/MM/YYYY')}</span></p>
            <p className="tags">
              {negoc.tag && negoc.tag.name ? <span>{negoc.tag.name}</span> : null}
            </p>
            <p className="description">
              {(negoc.fridge === null) ? "" : 'Planta de abate: ' + negoc.fridge.name + '\n'}
              {renderSwitch(negoc.slaughter_form)}
              Forma de Pagamento: {payment_form(negoc.payment_deadline)} para pagar<br />
            </p>
            <p className="description">
              Imposto: {tax_form(negoc.tax_form)} - FRETE: {(negoc.freight_responsibility === 'seller') ? 'FOB' : 'CIF'}
            </p>
            <p className="description">
              Frete por conta do: {(negoc.freight_responsibility === 'seller') ? 'Comprador - FOB' : 'Vendedor - CIF'}
            </p>
            <p className="description">Valor negociado: R$ {negoc.negotiated_value} {payment_measure(negoc.payment_measure)}</p>
            {mostraNegociacao(negoc.date)}
            <p className="description">
              Origem: {(negoc.city && negoc.city.name) || ''} / {(negoc.state && negoc.state.acronym) || ''}
            </p>
            {(negoc.slaughters || []).map((abates, index) => (
              <>
                <p className="description">
                  <strong>Abate {index + 1}</strong>
                </p>
                <p className="description">
                  Quantidade de Animais: {abates.animals_quantity}
                </p>
                <p className="description">
                  Rendimento do Abate: {abates.slaughter_yield}%
              </p>
                <p className="description">
                  Data do Abate: {Moment(abates.slaughter_date).format('DD/MM/YYYY')}
                </p>
              </>
            ))
            }
            <div id="clBotao">
              <button onClick={() => baixarPDF(negoc.id)}><FaFilePdf></FaFilePdf>Baixar PDF</button>
            </div>
            {/* <div>
              <PDFDownloadLink document={<MyDoc idDownload={negoc.id} />} fileName="somename.pdf">
                {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
                
              </PDFDownloadLink>
            </div> */}
            <div>
              <p className="description verde">
                {mostrarRecebidoEnviado(negoc)}
              </p>
            </div>
            <div>
              {mostrarBotoes(negoc)}
            </div>
            <div className="description">
              {(!negoc.reject_reason) ? '' : 'Motivo: ' + negoc.reject_reason}
            </div>
          </li>
        ))
      ));
    function traduzir(palavra) {
      switch (palavra) {
        case 'pending': {
          return "pendente"
        }
        case 'approved': {
          return "aprovado"
        }
        case 'rejected': {
          return "reprovada"
        }
        default: {
          return "";
        }
      }
    }
    function excluirNegocio(id) {
      if (window.confirm("Deseja realmente excluir essa necociação!?")) {
        var axios = require('axios');
        var FormData = require('form-data');
        var data = new FormData();

        var config = {
          method: 'delete',
          url: BASE_URL + `/v4/users/me/negotiations/${id}`,
          headers: {
            'USER_EMAIL': USER_EMAIL,
            'USER_TOKEN': USER_TOKEN,
            //...data.getHeaders()
          },
          data: data
        };

        axios(config)
          .then(function (response) {
          })
          .catch(function (error) {
          });
      }

    }
    function mostrarEditar(negoc) {
      if (negoc.status === 'pending') {
        if (negoc.reviwer !== null) {
          if (parseInt(negoc.reviwer.id) !== parseInt(sessionStorage.getItem('id'))) {

            return (
              <div className="edit"><Link to={'/negocio/alterar/' + negoc.id}>
                <FiEdit />Editar</Link>
                <Link className="icoExcluir" to="#" onClick={() => excluirNegocio(negoc.id)}>
                  <FiTrash2 className="icoExcluir" />Excluir
            </Link>
              </div>
            )
          }
        }
      }
    }

    function mostrarRecebidoEnviado(negoc) {
      //if (negoc.status === 'pending') {
      if (negoc.reviwer !== null) {
        if (parseInt(negoc.reviwer.id) === parseInt(sessionStorage.getItem('id'))) {
          return (
            <span>Recebido de: {negoc.reviwer.name}  -  <strong>{traduzir(negoc.reviewer_status)}</strong></span>
          )
        } else {
          return (
            <span>Enviado para: {negoc.reviwer.name}  -  <strong>{traduzir(negoc.reviewer_status)}</strong></span>
          )
        }
      }
      //}
    }
  }
  function mostrarBotoes(negoc) {
    if (negoc.reviwer !== null) {
      if (parseInt(negoc.reviwer.id) === parseInt(sessionStorage.getItem('id'))) {
        if (negoc.reviewer_status === 'pending') {
          return (
            <>
              <button className="btn-aprovar" onClick={() => aprovarNegocio(negoc.id)}>APROVAR</button>
              <button className="btn-rejeitar" onClick={() => rejeitarNegocio(negoc.id)}>REJEITAR</button>
            </>
          )
        }
      }
    }
  }
  function aprovarNegocio(id) {
    if (window.confirm("Deseja realmente APROVAR essa negociação?")) {
      var axios = require('axios');
      var data = '';

      var config = {
        method: 'post',
        url: BASE_URL + `/v5/users/me/negotiations/${id}/approve`,
        headers: {
          'Content-Type': 'application/json',
          'USER_EMAIL': USER_EMAIL,
          'USER_TOKEN': USER_TOKEN
        },
        data: data
      };

      axios(config)
        .then(function (response) {
          history.go(0)
        })
        .catch(function (error) {
        });
    }
  }
  function rejeitarNegocio(id) {
    var item = prompt("Você tem certeza?\nQue deseja rejeitar a negociação");
    if (item !== null || item !== "") {
      var axios = require('axios');
      var data = { "reject_reason": item };

      var config = {
        method: 'post',
        url: BASE_URL + `/v5/users/me/negotiations/${id}/reject`,
        headers: {
          'Content-Type': 'application/json',
          'USER_EMAIL': USER_EMAIL,
          'USER_TOKEN': USER_TOKEN
        },
        data: data
      };
      axios(config)
        .then(function (response) {
        })
        .catch(function (error) {
        });
    }
  }

  function mostraFree(visible) {
    const vPlan = JSON.parse(sessionStorage.getItem('plan')).name;
    if (vPlan === 'Consultoria gratuita') {
      if (visible === true) {
        return ('mostrarPost')
      } else {
        return ('esconderPost')
      }
    } else {
      return ('mostrarPost')
    }
  }
  return (
    <FeedLayout active="negotiations">
    <div className="negociacoes-container">
      <div className="feed-top">
        {t('pages.includes.header.negotiations')}
      </div>
      <div className="feed-chips">
        <button
          type="button"
          className={filtro === 'all' ? 'is-active' : ''}
          onClick={() => carregarNegociacao('all')}
        >
          {t('pages.includes.navNegotiations.negotiations')}
        </button>
        <button
          type="button"
          className={filtro === 'sent_received' ? 'is-active' : ''}
          onClick={() => carregarNegociacao('sent_received')}
        >
          {t('pages.includes.navNegotiations.sendReceive')}
        </button>
      </div>
      <section className="body">
        <ul>
          <ItemNeg />
        </ul>
        <div className="feed-sentinel" ref={sentinelRef}>
          {loadingMore && <span>Carregando mais negociações…</span>}
          {!loadingMore && !hasMore && posts.length > 0 && (
            <span>Você viu as negociações mais recentes</span>
          )}
        </div>
      </section>
    </div>
    </FeedLayout>
  );
}